/* Shiro's V15.7 — use Shopify's single featured photo for every menu/catalog tile outside homepage. */
(function () {
  'use strict';
  if (document.body && document.body.classList.contains('template-index')) return;
  var nodes=Array.prototype.slice.call(document.querySelectorAll('[data-shiros-image-sync][data-shiros-handle]'));
  if (!nodes.length) return;
  var cache=Object.create(null);
  function getPhoto(handle){
    if(!/^[a-z0-9][a-z0-9-]*$/.test(handle))return Promise.resolve('');
    if(!cache[handle]) cache[handle]=fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'})
      .then(function(r){if(!r.ok) throw Error('not available');return r.json();})
      .then(function(data){
         var photo=(data.featured_image || (data.images && data.images[0]) || '');
         if(typeof photo==='object')photo=photo.src||'';
         if(typeof photo!=='string')return '';
         if(photo.slice(0,2)==='//')photo='https:'+photo;
         if(photo.indexOf('https://')!==0 && photo.indexOf('http://')!==0 && photo.charAt(0)!=='/')return '';
         return photo;
      }).catch(function(){return '';});
    return cache[handle];
  }
  function load(node){
    if(node.dataset.shirosImageLoaded)return;
    node.dataset.shirosImageLoaded='yes';
    var handle=node.dataset.shirosHandle;
    getPhoto(handle).then(function(src){
      if(!src)return; // No approved product media: leave a warm beige empty image slot.
      var img=node.querySelector('img');
      if(!img){img=document.createElement('img');node.appendChild(img);}
      img.src=src;
      img.alt=(node.dataset.shirosTitle||handle.replace(/-/g,' '))+' at Shiro’s Bakery & Cafe';
      img.loading='lazy';
      img.decoding='async';
      img.style.objectFit='contain';
      node.classList.add('shiros-shopify-image-ready');
    });
  }
  if('IntersectionObserver' in window){
    var ob=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){ob.unobserve(e.target);load(e.target);}});},{rootMargin:'500px 0px'});
    nodes.forEach(function(n){ob.observe(n);});
  } else nodes.forEach(load);
})();
